import styled from 'styled-components';
import {FixedTableWrapper} from '../../elements/tableV1/tableFeatures/FixedTable';
import {ScrollBar} from '../../../shared-components/mixin/scroll/scrollBar';
import {LoadingStateWrapper} from '../../../shared-components/custom-features/loading-state/LoadingState';

export const ModalBody = styled(ScrollBar)`
    @-moz-document url-prefix() {
        overflow-y: auto;
        scrollbar-color: var(--scroll-bar-thumb-moz) var(--scroll-bar-thumb);
    }
    background: var(--app-background);

    overflow-y: auto;
    z-index: var(--z-index-modal-body);
    padding: var(--modal-padding);
    margin: 0px !important;
    border-radius: 0;

    .table-scroll-wrapper {
        max-height: calc(100vh - 500px);
        overflow: auto;
    }

    ${FixedTableWrapper} {
        max-height: calc(100vh - 400px);
        @media only screen and (max-height: 992px) {
            max-height: calc(100vh - 400px);
        }
        @media only screen and (max-height: 662px) {
            max-height: calc(100vh - 350px);
        }
    }

    ${LoadingStateWrapper} {
        position: unset;
        transform: unset;
        display: flex;
        justify-content: center;
        padding: 40px;
    }
`;
